// extracted by mini-css-extract-plugin
export default {"container":"styles_container__neV0V","title":"styles_title__XomXH"};